import * as React from 'react';
import {
    Card,
    CardContent,
    CardFooter,
    BlockTitle,
    Row,
    Col
} from 'framework7-react';

import './checkout.css'
import { withTranslation } from 'react-i18next';

import StripeCheckout from './stripeCheckout/StripeCheckout';
import VippsCheckout from './vippsCheckout/VippsCheckout';

class Checkout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          vipps: false,
          card: false
        }
      }

    render() {
    const { t } = this.props;
    if(this.props.vipps && this.props.stripe_key){
      return <>
            <BlockTitle style={{marginBottom:'4px'}}>{t('checkout.choose_payment_method')}</BlockTitle>
            <Row noGap className="checkout-block" style={{marginTop:0}}>
                <Col onClick={() => this.setState({vipps: true, card: false, invoice: false})} width="50">
                    <Card style={{marginRight:'10px'}} className={this.state.vipps?'card-selected':''}>
                        <CardContent>
                            <div className="card-inner-img-vipps"></div>
                        </CardContent>
                        <CardFooter>
                            <p>Vipps</p>
                        </CardFooter>
                    </Card>
                </Col>
                <Col onClick={() => this.setState({vipps: false, card: true, invoice: false})} width="50">
                    <Card style={{marginLeft:'10px'}} className={this.state.card?'card-selected':''}>
                        <CardContent>
                            <div className="card-inner-img-card"></div>
                        </CardContent>
                        <CardFooter>
                            <p>{t('checkout.payment_card')}</p>
                        </CardFooter>
                    </Card>
                </Col>
            </Row>
            {this.state.vipps &&
                <VippsCheckout sid={this.props.sid} price={this.props.price} reload={this.props.reload.bind(this)}/>
            }
            {this.state.card &&
                <StripeCheckout sid={this.props.sid} group={this.props.group} price={this.props.price} theme={this.props.theme} stripe_key={this.props.stripe_key} reload={this.props.reload.bind(this)}/>
            }
        </>;
      }else if(this.props.vipps){
        return <>
            <VippsCheckout sid={this.props.sid} price={this.props.price} reload={this.props.reload.bind(this)}/>
        </>;
      }else if(this.props.stripe_key){
        return <StripeCheckout sid={this.props.sid} group={this.props.group} price={this.props.price} theme={this.props.theme} stripe_key={this.props.stripe_key} reload={this.props.reload.bind(this)}/>;
      }
    }

};
export default withTranslation()(Checkout);